module.exports = __webpack_public_path__ + "img/Foto-Home-FL.6a26bd72.jpg";